module.exports = __webpack_public_path__ + "img/liveAlbum.e901367a.jpg";